<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  deactivated() {
    this.time = 60;
    this.timer = null;
  },
  activated() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        if (this.time > 0 && !this.sent) {
          this.time--;
        } else {
          clearInterval(this.timer);
          if (!this.sent) {
            this.sendResult();
            this.nextPage(this.next);
          }
        }
      }, 1000);
    }
  },
  data() {
    return {
      last: "P_46",
      next: "P_48",
      topic: "Estás en: Taller ¿Qué es crédito? / ¿Qué aprendí en esta lección?",
      dialog: false,
      correcta: false,
      respuesta: "none",
      sent: false,
      resultado: 0,
      time: 60,
      timer: null,
      interaction: {
        id: "TCC.L1.9.2",
        questionText: "Afirmaciones verdaderas",
        learnerResponse: "",
        correctAnswer: "",
        wasCorrect: true
      }
    };
  },
  methods: {
    sendResult() {
      if (this.correcta == this.respuesta) {
        this.resultado = 1;
      }
      this.sent = true;
      eventBus.$emit("send_result", this.resultado);
      eventBus.$emit("send_suspend_data", this.respuesta);
      // Record interactions
      var interaction = this.interaction;
      interaction.learnerResponse = this.respuesta;
      eventBus.$emit("record_interaction", interaction);
    }
  },
  created() {
    if ("suspend_data" in this.$parent) {
      if (this.$parent.currentPage in this.$parent.suspend_data) {
        this.respuesta = this.$parent.suspend_data[this.$parent.currentPage];
        this.sendResult();
      }
    }
  },
  computed: {
    responseIsNone() {
      return {
        "btn-primary": this.respuesta != "none",
        "btn-secondary": this.respuesta == "none"
      };
    }
  }
};
</script>

<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(:back='last') {{topic}}
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA 2 DE 5
            img.pt-3(style="width:61px; heigth:67px;", src="@/assets/cronometro.gif")
            v-card-text.chrono
              b {{("0" + Math.floor(time / 60)).slice(-2) +":" + ("0"+(time - Math.floor(time / 60) * 60)).slice(-2)}}
            v-card-text.titulo24Reg
              | Existen mitos y realidades alrededor de la TDC.
            v-card-text.parrafoDestacadoB.text-center Después de leer la siguiente afirmación, selecciona la respuesta que consideres correcta.
            v-card.questionCard(justify-center, flat)
              v-card-text.titulo18Book.text-center
                | Puedo elegir cualquier tipo de crédito para atender cualquier necesidad.
              v-layout.py-0.my-0(row, justify-center)
                v-flex(xs6, offset-xs2, justify-center)
                  v-radio-group(v-model='respuesta ', row)
                    v-radio.pt-0.px-4(color='primary ', :label='`Cierto` ', :value='true ')
                    div(v-if='sent && (respuesta==true) ')
                      v-icon(size='15px', color='red ') fas fa-times
                    v-radio.pt-0.px-4(color='primary ', :label='`Falso` ', :value='false ')
                    div(v-if='sent && (respuesta==false) ')
                      v-icon.mb-1(size='15px', color='green') fas fa-check
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false ')
                  v-btn.btn(color='secondary ', v-bind:class='responseIsNone ', :disabled="respuesta=='none' ", @click='sendResult() ')
                    | Enviar
                div(v-if='sent ')
                  v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                    | Retroalimentación
                  v-dialog(v-model='dialog ', persistent, max-width='930px ', content-class="dialog_over")
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          div(v-if='sent && (respuesta==false) ')
                            v-layout(v-if='dialog ')
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoOk.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Excelente!
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5
                                  | Existen muchos tipos de créditos y cada uno atiende necesidades distintas. 
                          div(v-if='sent && (respuesta!=false) ')
                            v-layout(v-if='dialog ')
                              v-flex(text-xs-center)
                                img.dialog_img(src='@/assets/ManoStop.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¿Seguro?  
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5
                                  | Recuerda que en realidad existen muchos tipos de créditos y cada uno atiende necesidades distintas.
                          v-btn.btn.dialog_btn.my-4(color='accent ', @click.prevent="nextPage(next)")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

